import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import AppLayout from '../Layouts/AppLayout/AppLayout';
import Results from '../Results/Results';
import BettingContainer from '../BettingContainer/BettingContainer';

function areEqual(prevProps, nextProps) {
    return prevProps !== nextProps;
}

const Main = () => {
    const match = useRouteMatch();
    return (
        <AppLayout>
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.path}/sports`} />
                <Route path={`${match.url}/results`} component={Results} />
                <BettingContainer match={match} />
            </Switch>
        </AppLayout>
    );
};

export default React.memo(Main, areEqual);
